import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import enUS from 'antd/locale/en_US';
import moment from 'moment';
import 'moment/locale/zh-cn';
import './styles/index.css';
import AppLayout from './components/AppLayout';
import HomePage from './pages/HomePage';
import RequestPage from './pages/RequestPage';
import PaymentPage from './pages/PaymentPage';
import ProfilePage from './pages/ProfilePage';
import AuthCallbackPage from './pages/AuthCallbackPage';
import PaymentResultPage from './pages/PaymentResultPage';
import { useAuth } from './utils/auth';

const locales = {
  en: enUS,
  zh: zhCN,
};

moment.locale('en');

function App() {
  const { user } = useAuth();

  return (
    <ConfigProvider locale={locales[user?.language] || enUS}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<AppLayout />} >
            <Route index element={<HomePage />} />
            <Route path="home" element={<HomePage />} />
            <Route path="requests" element={<RequestPage />} />
            <Route path="payment" element={<PaymentPage />} />
            <Route path="profile" element={<ProfilePage />} />
            <Route path="auth/callback" element={<AuthCallbackPage />} />
          </Route>
          <Route path="payments/:owner/:paymentName/result" element={<PaymentResultPage />} />
          <Route path="buy-plan/:owner/:pricingName/result" element={<PaymentResultPage />} />
        </Routes>
      </BrowserRouter>
    </ConfigProvider>
  );
}

export default App;